import Vue from "vue";
import Router from "vue-router";
import store from './store'

Vue.use(Router);
const role = store.getters['auth/role']
const rolesAllowed = ['admin', 'supervisor', 'manager']
const rolesAllowedPartial = ['supervisor', 'leader']

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/occupations",
      name: "occupations",
      component: () => import("./pages/Occupations"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/sectors",
      name: "sectors",
      component: () => import("./pages/Sectors"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/tasks",
      name: "tasks",
      component: () => import("./pages/Tasks"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/task-types",
      name: "task-types",
      component: () => import("./pages/TaskTypes"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./pages/Login")
    },
    {
      path: "/customers",
      name: "customers",
      component: () => import("./pages/Customers"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./pages/Users"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/users/create",
      name: "users-create",
      component: () => import("./pages/UsersCreate"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/users/edit/:id",
      name: "users-edit",
      component: () => import("./pages/UsersEdit"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/employee-costs",
      name: "employee-costs",
      component: () => import("./pages/EmployeeCosts"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/customer-fees",
      name: "customer-fees",
      component: () => import("./pages/CustomerFees"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/expenses",
      name: "expenses",
      component: () => import("./pages/Expenses"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/month-expenses",
      name: "month-expenses",
      component: () => import("./pages/MonthExpenses"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/holidays",
      name: "holidays",
      component: () => import("./pages/Holidays"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/tasks-made",
      name: "tasks-made",
      component: () => import("./pages/TasksMade")
    },
    {
      path: "/customers-service",
      name: "customer-service",
      component: () => import("./pages/CustomerService"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('/')
      }
    },
    {
      path: "/customers-service-v2",
      name: "customers-service-v2",
      component: () => import("./pages/CustomerServiceV2"),
      beforeEnter: (to, from, next) => {
        let role = store.getters['auth/role']
        if (role === 'leader' || role === 'employee') {
          next({ name: 'tasks-made' })
        } else {
          next()
        }
      }
    },
    {
      path: "/tasks-made-v2",
      name: "tasks-made-v2",
      component: () => import("./pages/TasksMadeV2"),
    },
    {
      path: "/service-record",
      name: "service-record",
      component: () => import("./pages/ServiceRecord"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('/')
      }
    },
    {
      path: "/service-record/:id/show",
      name: "service-record-show",
      component: () => import("./pages/PrintServiceRecord"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('/')
      }
    },
    {
      path: "/teams",
      name: "teams",
      component: () => import("./pages/Teams"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/teams/edit/:id",
      name: "teams-edit",
      component: () => import("./pages/TeamsEdit"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/squads",
      name: "squads",
      component: () => import("./pages/Squads"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/squads/edit/:id",
      name: "squads-edit",
      component: () => import("./pages/SquadsEdit"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/subsidiaries",
      name: "subsidiaries",
      component: () => import("./pages/Subsidiaries"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowed.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/tasks-made-users-worked",
      name: "tasks-made-users-worked",
      component: () => import("./pages/TasksMadeUsersWorked"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowedPartial.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/tasks-made-users",
      name: "tasks-made-users",
      component: () => import("./pages/TasksMadeUsers"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowedPartial.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/employee-resume",
      name: "employee-resume",
      component: () => import("./pages/EmployeeResume"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowedPartial.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/tasks-made-closure",
      name: "tasks-made-closure",
      component: () => import("./pages/TasksMadeClosure"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowedPartial.includes(role)) {
          next()
        } else next('tasks-made')
      }
    },
    {
      path: "/customer-cost-closure",
      name: "customer-cost-closure",
      component: () => import("./pages/CustomerCostClosure"),
      beforeEnter: (to, from, next) => {
        if (rolesAllowedPartial.includes(role)) {
          next()
        } else next('tasks-made')
      }
    }
  ]
});
